/**
 * SongReviewProgress Component
 *
 * Displays song metadata and review session progress.
 * Shows current card position, completion percentage, and average grade.
 * Includes visual progress bar.
 */

interface SessionProgress {
  reviewed: number
  total: number
  percentage: number
}

interface SongReviewProgressProps {
  songTitle: string | null
  songArtist?: string | null
  progress: SessionProgress
  averageGrade: number
}

export function SongReviewProgress({
  songTitle,
  songArtist,
  progress,
  averageGrade,
}: SongReviewProgressProps) {
  return (
    <>
      {/* Song Info and Progress Stats */}
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-sky-blue font-mono mb-1">
          {songTitle || 'Untitled Song'}
        </h1>
        {songArtist && (
          <p className="text-trail-tan font-mono text-sm">{songArtist}</p>
        )}
        <div className="mt-2 flex items-center gap-4 text-sm font-mono">
          <span className="text-terminal-green">
            Card {progress.reviewed + 1} of {progress.total}
          </span>
          <span className="text-sky-blue">
            Progress: {progress.percentage.toFixed(0)}%
          </span>
          {progress.reviewed > 0 && (
            <span className="text-trail-tan">
              Avg: {averageGrade.toFixed(1)}
            </span>
          )}
        </div>
      </div>

      {/* Progress Bar */}
      <div className="mb-4 w-full bg-black border-2 border-sky-blue h-4">
        <div
          className="h-full bg-terminal-green transition-all duration-300"
          style={{ width: `${progress.percentage}%` }}
        />
      </div>
    </>
  )
}
